var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ProbabilityClassifierConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { BaseClassifierConfig } from './baseClassifierConfig';
import { getRenamedColumns } from './toolConfigUtil';
import { ToolValidationResult, ToolValidationState } from './validation/toolValidationResult';
import { isSourceValid } from './validation/validateHelper';
import { probabilityClassifierConfigSchemaValidation } from '../validations.generated';
export const probabilityClassifierConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:ProbabilityClassifierConfig',
    type: 'object',
    properties: {
        threshold: { type: 'number', minimum: 0, maximum: 1 }
    },
    required: []
};
let ProbabilityClassifierConfig = ProbabilityClassifierConfig_1 = class ProbabilityClassifierConfig extends BaseClassifierConfig {
    constructor(toolType, labelColumn, threshold, excludeColumns, autoExclude, autoExcludeCorrMethod, autoExcludeCorrThreshold, autoExcludePpsThreshold, customFormats, performanceMeasureMethod) {
        super(toolType, labelColumn, excludeColumns, autoExclude, autoExcludeCorrMethod, autoExcludeCorrThreshold, autoExcludePpsThreshold, customFormats, performanceMeasureMethod);
        if (threshold !== undefined)
            this.threshold = threshold;
        JSON.validate(this, ProbabilityClassifierConfig_1);
    }
    getOutput(iConfigHelper, ins) {
        return this.getOutputForTrainableConfig(ins, this.in, this.out, ToolType.CLASSIFIER, this.labelColumn, this.labelColumnType, this.excludeColumns, true);
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        let hasLabel = false;
        let hasFeatures = false;
        const columnNames = source.map((col) => col.name);
        const predictionColumnName = getRenamedColumns(columnNames, 'Prediction', ToolType.CLASSIFIER);
        const probabilityColumnName = getRenamedColumns(columnNames, 'Probability', ToolType.CLASSIFIER);
        const outputs = new Set([predictionColumnName, probabilityColumnName]);
        const excludes = this.excludeColumns ? new Set(this.excludeColumns) : new Set();
        for (const column of source) {
            if (outputs.has(column.name)) {
                return ToolValidationResult.getBadMetadataResult(`Source column name '${column.name}' is reserved for output.`);
            }
            if (column.name === this.labelColumn) {
                hasLabel = true;
            }
            else if (!excludes.has(column.name)) {
                hasFeatures = true;
            }
        }
        if (hasLabel && hasFeatures) {
            return ToolValidationResult.getValidResult();
        }
        let comment;
        let suggestedFix;
        if (!hasLabel) {
            comment = `Label column is missing in the source columns.`;
            suggestedFix = `Select a label column from the source columns. Source columns: ${columnNames.join(', ')}`;
        }
        if (!hasFeatures) {
            comment = `There are no feature columns available for the model. Please ensure that at least one column, other than the label column, remains in the excludeColumns array.`;
            suggestedFix = `Adjust the 'excludeColumns' array to ensure that at least one column, excluding the label column, remains in the selection. Source columns: ${columnNames.join(', ')}`;
        }
        if (!hasLabel && !hasFeatures) {
            comment =
                'Label column is missing in the source columns. And there are no feature columns available for the model. Please ensure that at least one column, other than the label column, remains in the excludeColumns array.';
            suggestedFix = `Select a label column from the source columns. And adjust the 'excludeColumns' array to ensure that at least one column, excluding the label column, remains in the selection. Source columns: ${columnNames.join(', ')}`;
        }
        return ToolValidationResult.getBadMetadataResult(comment, suggestedFix);
    }
    isValidForRun(iConfigHelper, scope, pass) {
        if (pass) {
            const validInputs = scope.schemas.has(this.ins[0]);
            return validInputs ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
        }
        else {
            const source = scope.schemas.at(this.ins[0]);
            if (!source) {
                return ToolValidationState.BAD_METADATA;
            }
            const columnNames = source.map((col) => col.name);
            const predictionColumnName = getRenamedColumns(columnNames, 'Prediction', ToolType.CLASSIFIER);
            const probabilityColumnName = getRenamedColumns(columnNames, 'Probability', ToolType.CLASSIFIER);
            const outputs = new Set([predictionColumnName, probabilityColumnName]);
            return isSourceValid(source, new Set(), outputs) ? ToolValidationState.VALID : ToolValidationState.BAD_METADATA;
        }
    }
};
ProbabilityClassifierConfig = ProbabilityClassifierConfig_1 = __decorate([
    JsonSchemaV2(probabilityClassifierConfigSchema, probabilityClassifierConfigSchemaValidation)
], ProbabilityClassifierConfig);
export { ProbabilityClassifierConfig };
//# sourceMappingURL=probabilityClassifierConfig.js.map